import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=ff10a802&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff10a802')) {
      api.createRecord('ff10a802', component.options)
    } else {
      api.reload('ff10a802', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=ff10a802&", function () {
      api.rerender('ff10a802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25CGkOgM64KMW/JS/priceformat.vue"
export default component.exports